module.exports = __webpack_public_path__ + "media/images/beauty/marie-claire-fffcc3e7444b8dca7a3a52b56fd9b83c.jpg";